import { getCurrentTeam, getCurrentPlan, getIsOnTrial } from './store-service';

export const FEATURES = {
    import: {
        disable: [],
        onTrial: true
    },
    inviteGuests: {
        disable: ['X_Basic_Plan', 'X_Starter'],
        onTrial: false,
        name: 'Guest Accounts',
        description: 'Invite unlimited guest & client accounts into your projects for collaboration.',
        price: 20
    },
    timeTracking: {
        enable: ['X_Business_Yearly', 'X_Business_Monthly', 'X_Premium_Yearly', 'X_Premium_Monthly', 'X_Educational_Annual', 'X_Educational_Monthly', 'App_Sumo_1', 'App_Sumo_2', 'App_Sumo_3', 'App_Sumo_4', 'App_Sumo_5', 'App_Sumo_6', 'App_Sumo_7', 'App_Sumo_8', 'App_Sumo_9', 'App_Sumo_10', 'App_Sumo_11', 'App_Sumo_12', 'App_Sumo_13', 'App_Sumo_14', 'App_Sumo_15', 'App_Sumo_16', 'App_Sumo_17', 'App_Sumo_18', 'App_Sumo_19', 'App_Sumo_20'],
        onTrial: true,
        name: 'Time Tracking & Reporting',
        description: 'Track time spent on tasks and projects and gather operational insights.',
        price: 20
    },
    teamSSOOnly: {
        enable: ['X_Business_Yearly', 'X_Business_Monthly', 'X_Premium_Yearly', 'X_Premium_Monthly', 'X_Educational_Annual', 'X_Educational_Monthly', 'App_Sumo_1', 'App_Sumo_2', 'App_Sumo_3', 'App_Sumo_4', 'App_Sumo_5', 'App_Sumo_6', 'App_Sumo_7', 'App_Sumo_8', 'App_Sumo_9', 'App_Sumo_10', 'App_Sumo_11', 'App_Sumo_12', 'App_Sumo_13', 'App_Sumo_14', 'App_Sumo_15', 'App_Sumo_16', 'App_Sumo_17', 'App_Sumo_18', 'App_Sumo_19', 'App_Sumo_20'],
        onTrial: true
    },
    hideFromGuests: {
        enable: [],
        disable: ['X_Basic_Plan', 'X_Starter', 'X_Starter_Monthly', 'X_Starter_Yearly'],
        onTrial: true
    },
    customFields: {
        enable: ['X_Business_Yearly', 'X_Business_Monthly', 'X_Premium_Yearly', 'X_Premium_Monthly', 'X_Educational_Annual', 'X_Educational_Monthly', 'App_Sumo_1', 'App_Sumo_2', 'App_Sumo_3', 'App_Sumo_4', 'App_Sumo_5', 'App_Sumo_6', 'App_Sumo_7', 'App_Sumo_8', 'App_Sumo_9', 'App_Sumo_10', 'App_Sumo_11', 'App_Sumo_12', 'App_Sumo_13', 'App_Sumo_14', 'App_Sumo_15', 'App_Sumo_16', 'App_Sumo_17', 'App_Sumo_18', 'App_Sumo_19', 'App_Sumo_20'],
        onTrial: true
    },
    workloads: {
        enable: ['X_Business_Yearly', 'X_Business_Monthly', 'X_Premium_Yearly', 'X_Premium_Monthly', 'X_Educational_Annual', 'X_Educational_Monthly', 'App_Sumo_1', 'App_Sumo_2', 'App_Sumo_3', 'App_Sumo_4', 'App_Sumo_5', 'App_Sumo_6', 'App_Sumo_7', 'App_Sumo_8', 'App_Sumo_9', 'App_Sumo_10', 'App_Sumo_11', 'App_Sumo_12', 'App_Sumo_13', 'App_Sumo_14', 'App_Sumo_15', 'App_Sumo_16', 'App_Sumo_17', 'App_Sumo_18', 'App_Sumo_19', 'App_Sumo_20'],
        onTrial: true,
        name: 'Workloads',
        description: 'Visualize your team\'s tasks on a timeline view and balance workloads seamlessly.',
        price: 20
    },
    projectOverview: {
        disable: ['X_Basic_Plan', 'X_Starter', 'X_Starter_Monthly', 'X_Starter_Yearly'],
        onTrial: true
    },
    subteams: {
        disable: ['X_Basic_Plan', 'X_Starter'],
        onTrial: true
    }
};

const featureTypeExists = (featureType) => {
    if (!(featureType in FEATURES)) {
        console.error(`Features Service: illegal feature type: ${featureType}`);

        return false;
    }

    return true;
}

export const featureAvailable = (featureType, planDefault) => {
    const team = getCurrentTeam();
    const plan = getCurrentPlan();
    const onTrial = getIsOnTrial();

    if (!featureTypeExists(featureType)) {
        return false;
    }

    if (!plan) {
        return false;
    }

    if (team?.features?.includes(featureType) && !planDefault) {
        return true;
    }

    if (!FEATURES[featureType].onTrial && onTrial) {
        return false;
    }

    return (FEATURES[featureType].enable && FEATURES[featureType].enable.includes(plan)) || (FEATURES[featureType].disable && !FEATURES[featureType].disable.includes(plan));
}
